module.exports = __webpack_public_path__ + "static/media/ana.003cca7c.png";